<schedule-editor>
  <div class="modal fade" id="scheduleModal" tabindex="-1" aria-labelledby="scheduleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="scheduleModalLabel">
            Configuración de horarios: { props.deviceName || state.deviceName } - { props.channelName ||
            state.channelName }
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onclick={ handleClose
            }></button>
        </div>
        <div class="modal-body">
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="scheduleEnabled" checked={ state.schedule &&
                  state.schedule.enabled } onchange={ handleToggleEnabled } />
                <label class="form-check-label" for="scheduleEnabled">
                  Habilitar restricción horaria
                </label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="timezone">Zona horaria</label>
                <select class="form-select" id="timezone" value={ state.schedule && state.schedule.timezone } onchange={
                  handleTimezoneChange } disabled={ !state.schedule || !state.schedule.enabled }>
                  <option each={ tz in state.timezones } value={ tz }>{ tz }</option>
                </select>
              </div>
            </div>
          </div>

          <!-- Days of week selection -->
          <div class="mb-4">
            <label class="form-label">Días activos:</label>
            <div class="d-flex flex-wrap gap-2">
              <div class="form-check form-check-inline" each={ (day, index) in state.daysOfWeek }>
                <input class="form-check-input" type="checkbox" id={ 'day-' + index } value={ index } checked={
                  state.schedule && state.schedule.days && state.schedule.days.indexOf(index) !==-1 } onchange={ e=>
                handleDayToggle(e, index) }
                disabled={ !state.schedule || !state.schedule.enabled }
                />
                <label class="form-check-label" for={ 'day-' + index }>{ day }</label>
              </div>
            </div>
          </div>

          <!-- Time ranges -->
          <div class="card mb-4">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h6 class="mb-0">Rangos de hora</h6>
              <button type="button" class="btn btn-sm btn-primary" onclick={ addTimeRange } disabled={ !state.schedule
                || !state.schedule.enabled }>
                <i class="bi bi-plus-circle me-1"></i> Añadir rango
              </button>
            </div>
            <div class="card-body">
              <div if={ !state.schedule || !state.schedule.timeRanges || state.schedule.timeRanges.length===0 }
                class="alert alert-info">
                No hay rangos de hora configurados. Añade al menos uno.
              </div>

              <div class="time-ranges">
                <div if={ state.schedule && state.schedule.timeRanges } class="row mb-2 border-bottom pb-2" each={
                  (range, index) in state.schedule.timeRanges }>
                  <div class="col-md-5">
                    <label class="form-label">Hora inicio</label>
                    <input type="time" class="form-control" value={ range.startTime } onchange={ e=>
                    handleTimeRangeChange(e, index, 'startTime') }
                    disabled={ !state.schedule || !state.schedule.enabled }
                    />
                  </div>
                  <div class="col-md-5">
                    <label class="form-label">Hora fin</label>
                    <input type="time" class="form-control" value={ range.endTime } onchange={ e=>
                    handleTimeRangeChange(e, index, 'endTime') }
                    disabled={ !state.schedule || !state.schedule.enabled }
                    />
                  </div>
                  <div class="col-md-2 d-flex align-items-end">
                    <button type="button" class="btn btn-sm btn-outline-danger mb-2" onclick={ ()=>
                      removeTimeRange(index) }
                      disabled={ !state.schedule || !state.schedule.enabled || !state.schedule.timeRanges ||
                      state.schedule.timeRanges.length <= 1 }>
                        <i class="bi bi-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Exceptions -->
          <div class="card mb-4">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h6 class="mb-0">Excepciones (días festivos, etc.)</h6>
              <button type="button" class="btn btn-sm btn-primary" onclick={ addException } disabled={ !state.schedule
                || !state.schedule.enabled }>
                <i class="bi bi-plus-circle me-1"></i> Añadir excepción
              </button>
            </div>
            <div class="card-body">
              <div if={ !state.schedule || !state.schedule.exceptions || state.schedule.exceptions.length===0 }
                class="alert alert-info">
                No hay excepciones configuradas.
              </div>

              <div class="exceptions">
                <div if={ state.schedule && state.schedule.exceptions } class="card mb-3" each={ (exception, index) in
                  state.schedule.exceptions }>
                  <div class="card-header d-flex justify-content-between align-items-center py-2">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" id={ 'exception-enabled-' + index } checked={
                        exception.enabled } onchange={ e=> handleExceptionToggle(e, index) }
                      disabled={ !state.schedule || !state.schedule.enabled }
                      />
                      <label class="form-check-label" for={ 'exception-enabled-' + index }>
                        { exception.enabled ? 'Activo' : 'Inactivo' }
                        <span class="ms-2 badge bg-{ exception.enabled ? 'success' : 'danger' }">
                          { exception.enabled ? 'Abierto' : 'Cerrado' }
                        </span>
                      </label>
                    </div>
                    <div>
                      <button type="button" class="btn btn-sm btn-outline-danger" onclick={ ()=> removeException(index)
                        }
                        disabled={ !state.schedule || !state.schedule.enabled }
                        >
                        <i class="bi bi-trash"></i>
                      </button>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="row mb-3">
                      <div class="col-md-6">
                        <label class="form-label">Fecha</label>
                        <input type="date" class="form-control" value={ exception.date } onchange={ e=>
                        handleExceptionDateChange(e, index) }
                        disabled={ !state.schedule || !state.schedule.enabled }
                        />
                      </div>
                    </div>

                    <!-- Custom time ranges for this exception -->
                    <div if={ exception.enabled }>
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <h6 class="mb-0">Rangos de hora específicos (opcional)</h6>
                        <button type="button" class="btn btn-sm btn-outline-primary" onclick={ ()=>
                          addExceptionTimeRange(index) }
                          disabled={ !state.schedule || !state.schedule.enabled }
                          >
                          <i class="bi bi-plus-circle me-1"></i> Añadir
                        </button>
                      </div>

                      <div if={ !exception.timeRanges || exception.timeRanges.length===0 } class="alert alert-info">
                        Se usarán los rangos de hora generales.
                      </div>

                      <div class="exception-time-ranges">
                        <div if={ exception.timeRanges } class="row mb-2 border-bottom pb-2" each={ (range, rangeIndex)
                          in exception.timeRanges }>
                          <div class="col-md-5">
                            <label class="form-label">Hora inicio</label>
                            <input type="time" class="form-control" value={ range.startTime } onchange={ e=>
                            handleExceptionTimeRangeChange(e, index, rangeIndex, 'startTime') }
                            disabled={ !state.schedule || !state.schedule.enabled }
                            />
                          </div>
                          <div class="col-md-5">
                            <label class="form-label">Hora fin</label>
                            <input type="time" class="form-control" value={ range.endTime } onchange={ e=>
                            handleExceptionTimeRangeChange(e, index, rangeIndex, 'endTime') }
                            disabled={ !state.schedule || !state.schedule.enabled }
                            />
                          </div>
                          <div class="col-md-2 d-flex align-items-end">
                            <button type="button" class="btn btn-sm btn-outline-danger mb-2" onclick={ ()=>
                              removeExceptionTimeRange(index, rangeIndex) }
                              disabled={ !state.schedule || !state.schedule.enabled }
                              >
                              <i class="bi bi-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div if={ state.errors.length> 0 } class="alert alert-danger">
            <ul class="mb-0">
              <li each={ error in state.errors }>{ error }</li>
            </ul>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" onclick={ handleClose
            }>Cancelar</button>
          <button type="button" class="btn btn-primary" onclick={ handleSave } disabled={ state.isSaving ||
            state.errors.length> 0 }
            >
            { state.isSaving ? 'Guardando...' : 'Guardar cambios' }
          </button>
        </div>
      </div>
    </div>

  </div>

  <script>
    import { Modal } from 'bootstrap';
    import { DeviceService } from '../services/api-service';

    let modalInstance;

    export default {
      onBeforeMount() {
        this.state = {
          deviceId: '',
          deviceName: '',
          channelId: '',
          channelName: '',
          schedule: this.createDefaultSchedule(),
          originalSchedule: null,
          isSaving: false,
          errors: [],
          modalVisible: false,
          daysOfWeek: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
          timezones: [
            'UTC',
            'Europe/Madrid',
            'Europe/London',
            'America/New_York',
            'America/Los_Angeles',
            'America/Chicago',
            'America/Mexico_City',
            'America/Bogota',
            'America/Argentina/Buenos_Aires',
            'America/Santiago'
          ]
        };
        // Store modal instance as a component property, not as a local variable
        this.modalInstance = null;
      },

      onBeforeUnmount() {
        // Clean up event listeners when component is unmounted
        const modalElement = document.getElementById('scheduleModal');
        if (modalElement) {
          modalElement.removeEventListener('hidden.bs.modal', this.cleanupModal);
        }

        // Make sure modal is properly disposed
        if (this.modalInstance) {
          this.modalInstance.dispose();
          this.modalInstance = null;
        }
      },

      onMounted() {
        // Initialization of the Bootstrap modal
        const modalElement = document.getElementById('scheduleModal');
        if (modalElement) {
          this.modalInstance = new Modal(modalElement, {
            backdrop: 'static',
            keyboard: false
          });

          // Important: Add event listener to clean up backdrop when modal is hidden
          modalElement.addEventListener('hidden.bs.modal', this.cleanupModal);
        }

        // If we receive properties directly, update the state
        this.updateFromProps();
      },

      cleanupModal() {
        // Remove any stray backdrop elements
        const backdrops = document.querySelectorAll('.modal-backdrop');
        backdrops.forEach(backdrop => {
          backdrop.parentNode.removeChild(backdrop);
        });

        // Re-enable scrolling on the body if it was disabled
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
      },

      onUpdated() {
        // Actualizamos el estado cuando cambian las propiedades
        this.updateFromProps();
      },

      updateFromProps() {
        if (this.props.deviceId && this.props.channelId && this.props.schedule) {
          // Solo actualizamos si los datos son diferentes a los actuales
          if (
            this.props.deviceId !== this.state.deviceId ||
            this.props.channelId !== this.state.channelId
          ) {
            // Hacer una copia profunda del schedule
            const scheduleCopy = this.props.schedule ?
              JSON.parse(JSON.stringify(this.props.schedule)) :
              this.createDefaultSchedule();

            this.update({
              deviceId: this.props.deviceId,
              deviceName: this.props.deviceName,
              channelId: this.props.channelId,
              channelName: this.props.channelName,
              schedule: scheduleCopy,
              originalSchedule: JSON.parse(JSON.stringify(scheduleCopy))
            });

            // Validar el schedule
            this.validateSchedule();
          }
        }
      },

      // Crear una configuración por defecto
      createDefaultSchedule() {
        return {
          enabled: false,
          days: [1, 2, 3, 4, 5], // Lunes a viernes
          timeRanges: [{
            startTime: '08:00',
            endTime: '17:00'
          }],
          timezone: 'UTC',
          exceptions: []
        };
      },

      // Este método será llamado desde fuera si se usa como API pública
      open(deviceId, deviceName, channelId, channelName, currentSchedule) {
        this.update({
          deviceId: deviceId,
          deviceName: deviceName,
          channelId: channelId,
          channelName: channelName
        });

        // Si hay un schedule actual, usarlo, de lo contrario usar el default
        if (currentSchedule) {
          // Hace una copia profunda del schedule
          this.update({
            schedule: JSON.parse(JSON.stringify(currentSchedule)),
            originalSchedule: JSON.parse(JSON.stringify(currentSchedule))
          });
        } else {
          this.update({
            schedule: this.createDefaultSchedule(),
            originalSchedule: null
          });
        }

        // Validar el schedule inicial
        this.validateSchedule();

        // Mostrar el modal
        if (modalInstance) {
          modalInstance.show();
          this.update({ modalVisible: true });
        }
      },

      handleClose() {
        this.cleanupModal();
        this.resetState();
      },

      // Validar la configuración
      validateSchedule() {
        const errors = [];

        if (this.state.schedule && this.state.schedule.enabled) {
          // Verificar que hay al menos un día seleccionado
          if (!this.state.schedule.days || this.state.schedule.days.length === 0) {
            errors.push('Debe seleccionar al menos un día de la semana.');
          }

          // Verificar que hay al menos un rango de tiempo
          if (!this.state.schedule.timeRanges || this.state.schedule.timeRanges.length === 0) {
            errors.push('Debe añadir al menos un rango de horas.');
          }

          // Verificar que los rangos de tiempo son válidos
          if (this.state.schedule.timeRanges) {
            this.state.schedule.timeRanges.forEach((range, index) => {
              if (!range.startTime || !range.endTime) {
                errors.push(`El rango de horas #${index + 1} no tiene hora de inicio o fin.`);
              } else if (range.startTime >= range.endTime) {
                errors.push(`En el rango #${index + 1}, la hora de inicio debe ser anterior a la hora de fin.`);
              }
            });
          }

          // Validar excepciones
          if (this.state.schedule.exceptions) {
            this.state.schedule.exceptions.forEach((exception, index) => {
              if (!exception.date) {
                errors.push(`La excepción #${index + 1} no tiene fecha.`);
              }

              // Si la excepción está habilitada y tiene rangos de tiempo, validarlos
              if (exception.enabled && exception.timeRanges && exception.timeRanges.length > 0) {
                exception.timeRanges.forEach((range, rangeIndex) => {
                  if (!range.startTime || !range.endTime) {
                    errors.push(`En la excepción #${index + 1}, el rango #${rangeIndex + 1} no tiene hora de inicio o fin.`);
                  } else if (range.startTime >= range.endTime) {
                    errors.push(`En la excepción #${index + 1}, rango #${rangeIndex + 1}, la hora de inicio debe ser anterior a la hora de fin.`);
                  }
                });
              }
            });
          }
        }

        this.update({ errors });
        return errors.length === 0;
      },

      // Manejadores de eventos
      handleToggleEnabled(e) {
        if (!this.state.schedule) return;

        this.update({
          schedule: {
            ...this.state.schedule,
            enabled: e.target.checked
          }
        });

        this.validateSchedule();
      },

      handleTimezoneChange(e) {
        if (!this.state.schedule) return;

        this.update({
          schedule: {
            ...this.state.schedule,
            timezone: e.target.value
          }
        });

        this.validateSchedule();
      },

      handleDayToggle(e, dayIndex) {
        if (!this.state.schedule) return;

        let newDays = [...(this.state.schedule.days || [])];

        if (e.target.checked) {
          // Añadir el día si no está ya en la lista
          if (newDays.indexOf(dayIndex) === -1) {
            newDays.push(dayIndex);
            newDays.sort((a, b) => a - b);
          }
        } else {
          // Remover el día de la lista
          newDays = newDays.filter(d => d !== dayIndex);
        }

        this.update({
          schedule: {
            ...this.state.schedule,
            days: newDays
          }
        });

        this.validateSchedule();
      },

      addTimeRange() {
        if (!this.state.schedule) return;

        const newRange = { startTime: '08:00', endTime: '17:00' };
        const timeRanges = [...(this.state.schedule.timeRanges || []), newRange];

        this.update({
          schedule: {
            ...this.state.schedule,
            timeRanges
          }
        });

        this.validateSchedule();
      },

      removeTimeRange(index) {
        if (!this.state.schedule || !this.state.schedule.timeRanges) return;
        if (this.state.schedule.timeRanges.length <= 1) return; // Mantener al menos un rango

        const newRanges = [...this.state.schedule.timeRanges];
        newRanges.splice(index, 1);

        this.update({
          schedule: {
            ...this.state.schedule,
            timeRanges: newRanges
          }
        });

        this.validateSchedule();
      },

      handleTimeRangeChange(e, index, field) {
        if (!this.state.schedule || !this.state.schedule.timeRanges) return;

        const newRanges = [...this.state.schedule.timeRanges];
        newRanges[index] = {
          ...newRanges[index],
          [field]: e.target.value
        };

        this.update({
          schedule: {
            ...this.state.schedule,
            timeRanges: newRanges
          }
        });

        this.validateSchedule();
      },

      addException() {
        if (!this.state.schedule) return;

        // Obtener la fecha de mañana en formato YYYY-MM-DD
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        const formattedDate = tomorrow.toISOString().split('T')[0];

        const newException = {
          date: formattedDate,
          enabled: false
        };

        const exceptions = [...(this.state.schedule.exceptions || []), newException];

        this.update({
          schedule: {
            ...this.state.schedule,
            exceptions
          }
        });

        this.validateSchedule();
      },

      removeException(index) {
        if (!this.state.schedule || !this.state.schedule.exceptions) return;

        const exceptions = [...this.state.schedule.exceptions];
        exceptions.splice(index, 1);

        this.update({
          schedule: {
            ...this.state.schedule,
            exceptions
          }
        });

        this.validateSchedule();
      },

      handleExceptionToggle(e, index) {
        if (!this.state.schedule || !this.state.schedule.exceptions) return;

        const exceptions = [...this.state.schedule.exceptions];
        exceptions[index] = {
          ...exceptions[index],
          enabled: e.target.checked
        };

        this.update({
          schedule: {
            ...this.state.schedule,
            exceptions
          }
        });

        this.validateSchedule();
      },

      handleExceptionDateChange(e, index) {
        if (!this.state.schedule || !this.state.schedule.exceptions) return;

        const exceptions = [...this.state.schedule.exceptions];
        exceptions[index] = {
          ...exceptions[index],
          date: e.target.value
        };

        this.update({
          schedule: {
            ...this.state.schedule,
            exceptions
          }
        });

        this.validateSchedule();
      },

      addExceptionTimeRange(exceptionIndex) {
        if (!this.state.schedule || !this.state.schedule.exceptions) return;

        const exceptions = [...this.state.schedule.exceptions];
        const exception = exceptions[exceptionIndex];

        if (!exception.timeRanges) {
          exception.timeRanges = [];
        }

        exception.timeRanges.push({ startTime: '08:00', endTime: '17:00' });

        this.update({
          schedule: {
            ...this.state.schedule,
            exceptions
          }
        });

        this.validateSchedule();
      },

      removeExceptionTimeRange(exceptionIndex, rangeIndex) {
        if (!this.state.schedule || !this.state.schedule.exceptions) return;

        const exceptions = [...this.state.schedule.exceptions];
        const exception = exceptions[exceptionIndex];

        if (exception.timeRanges && exception.timeRanges.length > 0) {
          exception.timeRanges.splice(rangeIndex, 1);

          // Si no quedan rangos, eliminar el array
          if (exception.timeRanges.length === 0) {
            delete exception.timeRanges;
          }

          this.update({
            schedule: {
              ...this.state.schedule,
              exceptions
            }
          });

          this.validateSchedule();
        }
      },

      handleExceptionTimeRangeChange(e, exceptionIndex, rangeIndex, field) {
        if (!this.state.schedule || !this.state.schedule.exceptions) return;

        const exceptions = [...this.state.schedule.exceptions];
        const exception = exceptions[exceptionIndex];

        if (exception.timeRanges && exception.timeRanges[rangeIndex]) {
          exception.timeRanges[rangeIndex] = {
            ...exception.timeRanges[rangeIndex],
            [field]: e.target.value
          };

          this.update({
            schedule: {
              ...this.state.schedule,
              exceptions
            }
          });

          this.validateSchedule();
        }
      },

      async handleSave() {
        // Validar la configuración
        if (!this.validateSchedule()) {
          return;
        }

        this.update({ isSaving: true });

        try {
          // Llamar a la API para guardar la configuración
          const response = await DeviceService.updateChannelSchedule(
            this.state.deviceId,
            this.state.channelId,
            this.state.schedule
          );

          if (response.success) {
            // Notificar al componente padre
            if (this.props.onschedulesaved) {
              this.props.onschedulesaved({
                deviceId: this.state.deviceId,
                channelId: this.state.channelId,
                schedule: this.state.schedule
              });
            }
          } else {
            // Mostrar error
            this.update({
              errors: [response.message || 'Error al guardar la configuración']
            });
          }
        } catch (error) {
          console.error('Error al guardar schedule:', error);
          this.update({
            errors: [error instanceof Error ? error.message : 'Error desconocido']
          });
        } finally {
          this.update({ isSaving: false });
          this.cleanupModal();
        }
      },

      resetState() {
        this.update({
          deviceId: '',
          deviceName: '',
          channelId: '',
          channelName: '',
          schedule: this.createDefaultSchedule(),
          originalSchedule: null,
          isSaving: false,
          errors: [],
          modalVisible: false
        });
      }
    }
  </script>

</schedule-editor>
